<template>
    <div class="container">
        <!-- 订单状态标题 -->
        <div class="status-title">
            <div class="service-type">住院陪护</div>
            <div class="status-text" :class="order.statusTextClass">{{ orderInfo.statusTagName }}</div>
            <div class="status-text completed" v-if="order.status==-1">已取消</div>
            <div class="status-text completed" v-else-if="order.isPaid">已支付</div>
            <div class="status-text pending" v-else>待支付</div>
        </div>

        <!-- 订单详情卡片 -->
        <div class="card">
            <div class="card-title">订单详情</div>
            <div class="detail-row">
                <span class="label">订单编号</span>
                <span class="value">{{ order.orderNo }}</span>
            </div>
            <div class="detail-row">
                <span class="label">订单时间</span>
                <span class="value">{{ order.startTime }}</span>
            </div>
            <div class="detail-row">
                <span class="label">陪护服务</span>
                <span class="value">{{ (order.caregiverPlan && order.caregiverPlan.name) || '--' }}</span>
            </div>
            <div class="detail-row">
                <span class="label">套餐服务</span>
                <span class="value">￥{{ (order.caregiverPlan && order.caregiverPlan.price) || 0 }}</span>
            </div>
            <div class="detail-row">
                <span class="label">天数</span>
                <span class="value">{{ order.serviceDays }}天</span>
            </div>
            <div class="detail-row">
                <span class="label">被陪护人</span>
                <div class="value person-info">
                    <span class="name">{{ order.patientName }}</span>
                    <span class="tag age-tag">{{ order.patientAge }}</span>
                    <span class="tag gender-tag" v-if="order.patientGender">{{ order.patientGender }}</span>
                </div>
            </div>
            <div class="detail-row">
                <span class="label">科室</span>
                <span class="value">{{ order.divisionName }} {{ order.bedNumberCn }}</span>
            </div>
        </div>

        <!-- 费用详情卡片 -->
        <div class="card">
            <div class="card-title">费用详情</div>
            <div class="fee-row">
                <span class="label2">订单总金额：</span>
                <span class="amount total">¥ {{ order.paymentAmount }}</span>
            </div>
            <div class="fee-row">
                <span class="label2">已缴金额：</span>
                <span class="amount paid">¥ {{ order.paidAmount }}</span>
            </div>
            <div class="fee-row">
                <span class="label2">未缴金额：</span>
                <span class="amount unpaid">¥ {{ ((order.paymentAmount || 0) - (order.paidAmount || 0)).toFixed(2) }}</span>
            </div>
        </div>

        <div class="payTypes" v-if="order.status == 0 && (order.isPaid === undefined && order.isWait === undefined)">
            <div class="payType-title">支付方式</div>
            <div>
                <el-radio-group v-model="radio" style="width: 100%">
                    <div>
                        <div class="payType-radio payType-bottom">
                            <el-radio :label="1" class="custom-radio">
                                <el-image class="imgIcon" :src="require('../../assets/imgs/nonghang.png')"></el-image>
                                中国农业银行
                            </el-radio>
                        </div>
                        <div class="payType-radio payType-bottom">
                            <el-radio :label="2">
                                <el-image class="imgIcon" :src="require('../../assets/imgs/wxzf.jpeg')"></el-image>
                                微信支付
                            </el-radio>
                        </div>
                    </div>

                </el-radio-group>
            </div>
        </div>


        <!-- 底部按钮 -->
        <div class="footer-btn" v-if="order.status == -1">
            <button class="pay-btn" :class="orderInfo.statusTextClass" @click="returnClick">返回</button>
        </div>
        <div class="footer-btn" v-else-if="order.isPaid === undefined && order.isWait === undefined">
            <button class="pay-btn" @click="orderAdd(orderInfo)">去缴费</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'orderDetail',
        data() {
            return {
                orderInfo: {},
                order: {},
                showQRModal: false,
                qrImageUrl: '',
                payStatus: -1,
                // 临时变量
                _currentOrder: null,
                _orderCenterId: '',
                _payPollTimer: null,

                radio: 1,
            }
        },
        mounted() {
            this.initPage()
        },
        methods: {
            // 页面初始化：解析路由参数
            initPage() {
                this.orderId = this.$route.query.orderId
                this.fetchOrderDetail(this.orderId)
            },

            // 请求订单详情
            async fetchOrderDetail(orderId) {
                try {
                    let url = "/api-enterprise/employee/order/detail"
                    let query = {
                        orderId: orderId
                    }
                    this.$api.post(url, query, response => {
                        if (response.data.result == "success") {
                            let orderData = response.data.data
                            if (Array.isArray(orderData) && orderData.length > 0) {
                                orderData = orderData[0]
                            }
                            if (orderData && typeof orderData === 'object') {
                                this.order = this.formatOrder(orderData)
                            }
                        }
                    })
                } catch (err) {
                    console.error('fetchOrderDetail fail:', err)
                }
            },

            // 格式化订单数据
            formatOrder(order) {
                const plan = order.caregiverPlan || {}
                return {
                    ...order,
                    planName: plan.name || '陪护服务',
                    planPrice: plan.price || 0,
                    divisionBed: order.bedNumber
                        ? (order.divisionName + order.bedNumberCn)
                        : order.divisionName || '--',
                    patientName: order.patientName || '--',
                    patientAge: order.patientAge || '',
                    patientGender: order.patientGender || '',
                    orderNo: order.orderNo || '--',
                    startTime: order.startTime || '--',
                    endTime: order.endTime || '--',
                    actualDays: order.actualDays || 0,
                    settleAmount: order.settleAmount || 0,
                    settled: order.status === 100
                }
            },

            // 返回上一页
            returnClick() {
                this.$router.back()
            },

            orderAdd() {
                if (this.radio == 1) {
                    let _this = this
                    let url = '/api-enterprise/pay/prepare5'
                    let query = {
                        paymentId: _this.order.paymentId,
                        innerApp:true
                    }
                    this.$api.post(url, query, function (res) {
                        if (res.data.result == "success") {
                            let dynamicData = res.data.dynamicData
                            window.location.href = 'https://wx.abchina.com/webank/main-view/openTagForId?id=k0WoqSSxzqs%3D&dynamicData=' + dynamicData;
                        }
                    })
                } else {
                    let _this = this
                    let url = '/api-enterprise/pay/prepare5'
                    let query = {
                        paymentId: _this.order.paymentId,
                    }

                    this.$api.post(url, query, function (res) {
                        if (res.data.result == "success") {
                            let JSAPI = res.data.JSAPI
                            // 微信支付
                            WeixinJSBridge.invoke('getBrandWCPayRequest', {
                                appId: JSAPI.sub_appId,   // 上一步得到的参数
                                nonceStr: JSAPI.nonceStr, // 上一步得到的参数
                                package: JSAPI.package,   // 上一步得到的参数
                                signType: JSAPI.signType, // 上一步得到的参数
                                timeStamp: JSAPI.timeStamp,   // 上一步得到的参数
                                paySign: JSAPI.paySign    // 上一步得到的参数
                            }, res => {
                                // 根据get_brand_wcpay_request的值判断支付状态
                                if (res.err_msg === "get_brand_wcpay_request:ok") {
                                    // ok：支付成功，刷新订单详情并跳转
                                    _this.fetchOrderDetail(_this.orderId)
                                    setTimeout(() => {
                                        _this.$router.replace({path: '/order'})
                                    }, 500)
                                } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                                    // cancel：用户取消支付
                                    _this.$message.warning('支付已取消')
                                } else if (res.err_msg === "get_brand_wcpay_request:fail") {
                                    // fail：支付失败
                                    _this.$message.error('支付失败，请重试')
                                }
                            })
                        }
                    })
                }

            },
        }
    }
</script>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
    }

    /* 状态标题 */
    .status-title {
        text-align: center;
        margin-bottom: 15px;
        width: 96%;
        background: linear-gradient(135deg, #2d8a7a 0%, #1e6b5f 100%);
        border-radius: 12px;
        padding: 28px 20px;
        box-shadow: 0 4px 15px rgba(45, 138, 122, 0.4);
    }

    .service-type {
        font-size: 15px;
        color: #ffffff;
        margin-bottom: 10px;
        font-weight: 600;
        letter-spacing: 2px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    }

    .status-text {
        font-size: 32px;
        color: #ffffff;
        font-weight: 700;
        text-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
        letter-spacing: 3px;
    }

    /* 通用卡片样式 */
    .card {
        background: #fff;
        border-radius: 6px;
        padding: 15px;
        margin-bottom: 10px;
        width: 96%;
    }

    .card-title {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 10px;
        margin-bottom: 5px;
        border-bottom: 2px solid rgba(153, 153, 153, 0.4);
    }

    /* 订单详情行 */
    .detail-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        font-size: 14px;
    }

    .detail-row:last-child {
        margin-bottom: 0;
    }

    .label {
        width: 60px;
        color: #666;
        text-align: right;
        font-size: 14px;
    }

    .label2 {
        width: 76px;
        color: #101010;
        font-size: 12px;
        text-align: right;
    }

    .value {
        flex: 1;
        color: #333;
        text-align: left;
        margin-left: 15px;
    }

    /* 人员信息标签 */
    .person-info {
        display: flex;
        align-items: center;
    }

    .name {
        margin-right: 8px;
    }

    .tag {
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 12px;
        margin-right: 5px;
    }

    .age-tag {
        color: rgba(0, 184, 147, 0.72);
        background: rgba(187, 187, 187, 0.3);
    }

    .gender-tag {
        color: rgba(0, 184, 147, 0.72);
        background: rgba(187, 187, 187, 0.3);
    }

    /* 费用详情行 */
    .fee-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        font-size: 14px;
    }

    .fee-row:last-child {
        margin-bottom: 0;
    }

    .amount.total {
        color: #333;
        font-weight: bold;
    }

    .amount.paid {
        color: #40c9a2;
    }

    .amount.unpaid {
        color: #f56c6c;
        font-weight: bold;
    }

    /* 底部按钮 */
    .footer-btn {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 10px;
        background-color: #fff;
    }

    .pay-btn {
        width: 100%;
        background-color: #40c9a2;
        color: #fff;
        border-radius: 6px;
        font-size: 16px;
        border: none;
        padding: 10px;
    }

    .status-text.completed {
        color: #ffffff;
        text-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
    }

    .payTypes {
        width: 96%;
        padding: 15px;
        border-radius: 10px;
        background: white;
        margin-bottom: 80px;
    }

    .payType-title {
        border-bottom: 1px solid #cccccc;
        height: 30px;
        line-height: 30px;
        padding: 0 15px;
        color: #292929;
    }

    .payType-bottom {
        border-bottom: 1px solid #cccccc;
    }

    .payType-radio /deep/ .el-radio {
        width: 100%;
        padding: 0 20px;
        height: 50px;
        line-height: 50px;
        box-sizing: border-box;
    }

    .payType-radio /deep/ .el-radio__label {
        display: flex;
        font-size: 16px;
        align-items: center;
    }

    .payType-radio /deep/ .el-radio__input {
        float: right;
        display: flex;
        align-items: center;
        height: 100%;
    }


    .imgIcon {
        width: 25px;
        height: 25px;
        padding: 0 5px;
    }

    .completed {
        color: #999;
    }

    .pending {
        color: #07c160;
    }
</style>
